import React from 'react';
import { Spinner, SpinnerSize } from 'ui-toolkit';

interface ISpinnerWrapperProps {
  spinning: boolean;
  children: React.ReactNode;
}

export default class SpinnerWrapper extends React.Component<ISpinnerWrapperProps> {
  public render() {
    const { children, spinning } = this.props;
    return spinning ? (
      <div style={{ alignItems: 'center', display: 'flex', justifyContent: 'center', padding: '16px' }}>
        <Spinner size={SpinnerSize.regular} />
      </div>
    ) : (
      children
    );
  }
}
